import { FulfillmentEmailCard } from "../../rows/FulfillmentEmailCard";
import { AutomatedCommunicationsFormData, RowKey } from "../../types";

interface BuildFulfillmentRowsParams {
  hasPickupEmail: boolean;
  hasShippingEmail: boolean;
  openRow: RowKey | null;
  onToggleOpen: (row: RowKey) => void;
  defaultValues: AutomatedCommunicationsFormData;
}

export const buildFulfillmentRows = ({
  hasPickupEmail,
  hasShippingEmail,
  openRow,
  onToggleOpen,
  defaultValues,
}: BuildFulfillmentRowsParams): { key: RowKey; node: React.ReactNode }[] => {
  const shared = { openRow, onToggleOpen };
  const rows: { key: RowKey; node: React.ReactNode }[] = [];

  if (hasPickupEmail) {
    rows.push({
      key: "ready-for-pickup",
      node: (
        <FulfillmentEmailCard
          kind="ready-for-pickup"
          {...shared}
          defaultContent={defaultValues.readyForPickup.content}
        />
      ),
    });
  }

  if (hasShippingEmail) {
    rows.push({
      key: "order-shipped",
      node: (
        <FulfillmentEmailCard kind="order-shipped" {...shared} defaultContent={defaultValues.orderShipped.content} />
      ),
    });
  }

  return rows;
};
